import { render, staticRenderFns } from "./index.vue?vue&type=template&id=63ce910b"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppHeader: require('/home/forge/ab.farescraper.com/components/AppHeader.vue').default,BlogBreadcrumbs: require('/home/forge/ab.farescraper.com/components/BlogBreadcrumbs.vue').default,BlogListDefault: require('/home/forge/ab.farescraper.com/components/BlogListDefault.vue').default,AppFooter: require('/home/forge/ab.farescraper.com/components/AppFooter.vue').default})
